import { createContext, useContext } from "react";

/**
 * Where the popups below a `PortalScope` render: a node inside that scope, so a menu, dialog or
 * tooltip takes the scope's tokens (a page-scoped palette) instead of the page root's. Null, the
 * default, means `<body>`, which is where every popup renders outside a scope.
 */
export const PortalContainerContext = createContext<HTMLElement | null>(null);

/** The node this subtree's popups render into, or undefined for `<body>`. */
export function usePortalContainer(): HTMLElement | undefined {
  return useContext(PortalContainerContext) ?? undefined;
}
